<template>
  <div id="page">
        <Navbar :title="'Dashboards'" :backBtn="'Home'"/>
        <div class="page-content header-clear-medium padding-sides">
            <div class="travel-list-container">
                <h2 class="bold center-text">Dashboards</h2>
                <div class="divider divider-margins"></div>
                <div class="center-allign">
                    <router-link :to="{ name: 'NewDashboard' }" class="ui-button ui-button--type-primary ui-button--color-primary ui-button--icon-position-left ui-button--size-normal">New Dashboard</router-link>
                </div>
                <div class="divider divider-margins"></div>
                <DashboardsList/>
            </div>
        </div>
        <div class="menu-hider"></div>
    </div>
</template>

<script>
import Navbar from '@/components/layouts/Navbar'
import DashboardsList from '@/components/dashboards/DashboardsList'

export default {
    name: 'Unifon',
    components:{
        Navbar,
        DashboardsList
    },
}
</script>

<style>

</style>